module.exports = __webpack_public_path__ + "img/logo.2ab3959c.png";